import { useEffect, useId } from 'react';

import { useAgentContext } from './AgentContextProvider';
import type { AgentContextEntry } from './types';

export const useRegisterAgentContext = (entry: AgentContextEntry | null) => {
  const ctx = useAgentContext();
  const id = useId();

  // No cleanup: it would drop the entry for the rest of the commit, and a message sent in that window goes without it. Removal is unmount-only, below.
  useEffect(() => {
    if (entry) ctx?.registerEntry(id, entry);
    else ctx?.unregisterEntry(id);
  });

  useEffect(() => () => ctx?.unregisterEntry(id), [ctx, id]);
};
